import React from 'react';
import './LanguageSelectorStyles.scss';
import { useIntl } from 'react-intl';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import DropdownList from '../Dropdown/DropdownList';
import { Icons } from '../BootstrapComponents/BootstrapComponents';
import { getSystemData } from '../../../modules/System/reducer';
import { setLocale } from '../../../modules/System/actions';

const availableLanguage = ['ru', 'en'];

export default function LanguageSelector(props) {
  const { locale = 'ru' } = useSelector(getSystemData);
  const dispatch = useDispatch();
  const intl = useIntl();
  const { formatMessage } = intl;
  const setLanguage = name => () => {
    dispatch(setLocale(name));
  };
  const toggleButton = (
    <div className="language-selector-toggle">
      <div className="language-selector-toggle-flag">
        <Icons width={22} height={22} customIcon icon={`${locale}-flag`} className="button-icons" />
      </div>
      <div className="language-selector-toggle-text">{locale}</div>
      <div className="language-selector-toggle-arrow">
        <Icons width={14} height={7} customIcon icon="arrow-down" className="button-icons" />
      </div>
    </div>
  );
  return (
    <DropdownList label={toggleButton} className="language-selector-wrapper" menuClassName="dropdown-language-selector">
      <div className="language-selector-list">
        {
          availableLanguage.map((name, index) => (
            <div key={index} className={classNames('language-selector-item', { selected: name === locale })} onClick={setLanguage(name)}>
              <div className="language-selector-item-flag">
                <Icons width={22} height={22} customIcon icon={`${name}-flag`} className="button-icons" />
              </div>
              <div className="language-selector-item-text">{formatMessage({ id: `locale.${name}` })}</div>
            </div>
          ))
        }
      </div>
    </DropdownList>
  );
}
